
var escapeHtml = require('escape-html');
var _ = require('underscore');
var locale = require('locale');

var allLocales = require('../../config/supportedLanguages').supportedLanguages;

var _htmlEscape = function(text, shouldEscapeHtml) {
    if (shouldEscapeHtml && text) {
        return escapeHtml(text);
    } else {
        return text;
    }
};

var _wrap = function(text, shouldWrap) {
    if (shouldWrap) {
        if (text == null) {
            return 'X (MISSING TEMPLATE) X';
        } else {
            return '✓ ' + text + ' ✓';
        }
    } else {
        return text;
    }
};

var _isHtmlTranslation = function(key) {
    return key && key.toLowerCase().endsWith('html');
};

var formatLocalizedText = function(key, text, options) {
    options = options || {};

    var shouldEscapeHtml = options.expectHtml && !_isHtmlTranslation(key);
    var shouldWrap = !!options.wrap;

    var possiblyHtmlEscaped = _htmlEscape(text, shouldEscapeHtml);
    var possiblyWrapped = _wrap(possiblyHtmlEscaped, shouldWrap);

    return possiblyWrapped || '';
};

var getLanguageHeaderLocale = function(req, libraryPrimaryLocale) {
    // Get all supported languages
    var supportedLanguages = new locale.Locales(_.flatten(_.pluck(allLocales, 'defaultLanguageCode')), libraryPrimaryLocale);
    var locales = new locale.Locales(req.headers['accept-language']);
    var bestLanguage = locales.best(supportedLanguages).toString();
    if (bestLanguage === 'zh-Hans' && req.headers['accept-language'].toLowerCase().includes("zh")
            && (libraryPrimaryLocale === 'zh-Hans' || libraryPrimaryLocale === 'zh-Hant')) {
        bestLanguage = libraryPrimaryLocale;
    }
    return bestLanguage;
};

var getLocale = function(req, libraryPrimaryLocale) {
    if (req.query && req.query._locale) {
        return req.query._locale;
    } else if (req.profile && req.profile.settings && req.profile.settings['language-selection']) {
        return req.profile.settings['language-selection'];
    } else if (req.cookies && req.cookies['language-selection']) {
        return req.cookies['language-selection'];
    } else if (req.headers['accept-language']) {
        return getLanguageHeaderLocale(req, libraryPrimaryLocale);
    } else if (libraryPrimaryLocale) {
        return libraryPrimaryLocale;
    } else {
        return 'en';
    }
};

var getTranslationOptions = function(locale, expectHtml) { // eslint-disable-line no-shadow
    return {
        expectHtml: expectHtml,
        wrap: locale && locale.toLowerCase() === 'en-qa'
    };
};

module.exports = {
    formatLocalizedText,
    getLocale,
    getTranslationOptions,
    getLanguageHeaderLocale
};
